var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isBrandable
    ? _c("BrandableProduct", { attrs: { selectedAddon: _vm.curatedBox } })
    : _c("NormalProduct", { attrs: { curatedBox: _vm.curatedBox } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }